define('SageDotCom/Utility/sageLoader',[], () => {
    function SageLoader() { }

    SageLoader.prototype.initialize = function () {
        this.createLoaderElement();
        this.attachLoaderListeners();
    };

    SageLoader.prototype.createLoaderElement = function () {
        if (!document.querySelector(".sage-loader")) {
            const container = document.createElement("div");
            const spinner = document.createElement("span");

            container.className = "sage-loader";
            spinner.classList.add("icon-loader", "icon-loader-big", "icon-loader-green");

            container.appendChild(spinner);
            document.body.appendChild(container);
        }
    };

    SageLoader.prototype.attachLoaderListeners = function () {
        const loader = document.querySelector(".sage-loader");
        if (!loader) return;

        let loaderScheduled = false;

        const showLoader = () => {
            loader.classList.add("show");

            if (!loaderScheduled) {
                loaderScheduled = true;
                requestAnimationFrame(() => {
                    loader.classList.add("fadeIn");
                    loaderScheduled = false;
                });
            }
        };

        document.querySelectorAll("a.hasLoader, button.hasLoader").forEach((el) => {
            el.addEventListener("click", showLoader);
        });
    };

    return new SageLoader();
});

